import { useState, useEffect, useRef } from "react";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { MainHerosection } from "../../Components/HeroSection";
import QSleeveImage from "../../Images/videothumbnail.jpg";

import { homepagebox } from "../../Data/Aboutus";
import { HomeBoxHover } from "../../Components/BoxHover";
import global from "../../../src/Images/globe.png";
import BackgroundGradient from "../../Images/BackgroundGradient.png";
import BackgroundGradientSmall from "../../Images/BackgroundGradientSmall.png";
import VideoComponent from "../../Components/VideoComponent";
import ScamAlertPopup from "../../Components/ScamAlertPopup";

export default function QAIGHome() {
  // const backgroundImageBig = generateSvgDataUrl("#060606", 70, 70);
  // const backgroundImageSmall = generateSvgDataUrl("#060606", 50, 50);
  // const [backgroundImage, setBackgroundImage] = useState(backgroundImageSmall);
  const VideoRef = useRef(null);
  const [toggle, setToggle] = useState(false);

  const [backgroundImage, setBackgroundImage] = useState(``);

  useEffect(() => {
    const updateBackgroundImage = () => {
      if (window.innerWidth < 640) {
        setBackgroundImage(`url(${BackgroundGradientSmall})`);
      } else {
        setBackgroundImage(`url(${BackgroundGradient})`);
      }
    };

    updateBackgroundImage();
    window.addEventListener("resize", updateBackgroundImage);
    return () => window.removeEventListener("resize", updateBackgroundImage);
  }, []);

  const scrollToVideo = () => {
    if (!VideoRef.current) return;

    VideoRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start", // important
    });
  };

  // useEffect(() => {
  //   const updateBackgroundImage = () => {
  //     const screenWidth = window.innerWidth;

  //     if (screenWidth >= 1536) {
  //       setBackgroundImage(backgroundImageBig);
  //     } else {
  //       setBackgroundImage(backgroundImageSmall);
  //     }
  //   };

  //   updateBackgroundImage();

  // }, []);
  const handleToggle = () => {
    setToggle(!toggle);
  };

  return (
    <div className="w-full  flex flex-col gap-0 items-center justify-center bg-primary7">
      <div
        className="w-full   width flex flex-col gap-0 items-center justify-center bg-contain bg-repeat"
        style={{ backgroundImage: backgroundImage }}
      >
        <Header id={1} />
        <div className="w-full h-[25rem] ">
          <MainHerosection
            title1="Welcome To"
            title2="Quantum AI Global"
            content="Leading the way in Quantum & AI Solutions"
            MainHerosection={scrollToVideo}
          />
        </div>
        <div className="w-full bg-primary7  width flex flex-col items-center justify-center md:px-10 2xl:px-20 gap-6 pb-10 relative">
          <div className="w-full h-auto lg:h-[40rem] p-3 width grid grid-cols-1 lg:grid-cols-2 justify-items-center   items-center  ">
            <div className="w-full md:w-[90%] h-full flex flex-col justify-center items-center   p-3">
              <div className="w-full  flex flex-col items-center justify-center gap-1">
                <div className="w-full  text-center md:text-left text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem] font-RobotoBold text-white leading-tight px-3">
                  Explore Quantum Revolution at
                </div>{" "}
                <div className="w-full  text-center md:text-left text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem] font-RobotoBold wordGradient leading-tight px-3 mb-3">
                  {" "}
                  Quantum AI Global
                </div>
              </div>
              <div className="w-full text-white text-center md:text-left font-RobotoRegular text-xs md:text-sm px-3 ">
                Quantum AI Global is unique in its approach to Quantum
                Technology powered by Intelligence. We are the forefront of the
                quantum development in hardware and software. We started our
                work in late 2018 with the establishment of Qulabs, a dedicated
                Quantum lab under Quantum AI Global with a vision to build and
                commercialise technologies necessary for long-distance
                quantum-secure communication in India.
              </div>
              <div className="w-full text-white text-center md:text-left font-RobotoRegular text-xs md:text-sm px-3 ">
                We thrive on our motto ‘collaboration and not competition’, a
                practical direction to unite intelligence towards building
                applications for quantum technologies.
              </div>
              <div className="w-full hidden xl:block z-10  px-3">
                <HomeBoxHover items={homepagebox} />
              </div>
            </div>
            <img
              src={global}
              className="w-full max-w-[32.75rem] h-auto object-contain"
            ></img>
          </div>
          <div className="w-full xl:hidden block z-10  ">
            <HomeBoxHover items={homepagebox} />
          </div>
          <div
            className="absolute -z-2 left-1/2 top-[60%] transform -translate-x-1/2 -translate-y-1/2 inset-0 md:w-[80%] md:h-[12rem]"
            style={{
              background:
                "radial-gradient(circle at center, rgba(70,196,255,0.2), transparent )",
              filter: "blur(70px)",
            }}
          ></div>
        </div>
        <div ref={VideoRef} className="w-full">
          <VideoComponent
            image={QSleeveImage}
            video={"https://thequantum.ai/videos/Companyppt.mp4"}
          />
        </div>
        <Footer showpage={true} />
        <ScamAlertPopup />
      </div>
    </div>
  );
}
